export default [
    {
        path: '/portfolio-photos',
        name: 'portfolio-photo',
        meta: { requiresAuth: true },
        component: () => import('@/pages/portfolio-photo/index.vue')
    },
    {
        path: '/portfolio-preview-lists',
        name: 'portfolio-preview-list',
        meta: { requiresAuth: true },
        component: () => import('@/pages/portfolio-photo/preview-list.vue')
    }
]
